import { en } from "../i18n/en/index.js";
import { Pick } from "./card.js";
/** The tap choices and recognizer hints both interviews offer: yes or no, and the pilot's areas. */
export const YES_NO = [
    { value: Pick.yes, key: "flag.yes" },
    { value: Pick.no, key: "flag.no" },
];
/** Which script a language's recognizer expects its words in, to pick area names worth biasing it towards. */
const SCRIPT = {
    en: /\p{Script=Latin}/u,
    hi: /\p{Script=Devanagari}/u,
    kn: /\p{Script=Kannada}/u,
};
export const isMessageKey = (key) => key in en;
/** A chip for each area the catalog names. */
export const areaChoices = (areas) => areas.flatMap((a) => {
    const key = `area.${a.key}`;
    return isMessageKey(key) ? [{ value: a.key, key }] : [];
});
/** The areas' names written in the owner's script, for the recognizer. */
export const areaHints = (areas, own) => areas.flatMap((a) => a.names.filter((n) => SCRIPT[own].test(n)));
//# sourceMappingURL=choices.js.map